import { render, staticRenderFns } from "./ReCaptchaV3.vue?vue&type=template&id=0c1d623e&"
import script from "./ReCaptchaV3.vue?vue&type=script&lang=js&"
export * from "./ReCaptchaV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports